import { useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  checkState,
  type UserStateInfo,
  type CheckStateResult,
} from "@/pages/auth/post_login/checkState";

export const useUserStateStepper = () => {
  const [isStepperOpen, setIsStepperOpen] = useState(false);
  const [userStateInfo, setUserStateInfo] = useState<UserStateInfo | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const hasCheckedState = useRef(false);

  const checkUserState = useCallback(async () => {
    // Prevent multiple simultaneous calls
    if (isLoading || hasCheckedState.current) {
      return;
    }

    hasCheckedState.current = true;
    setIsLoading(true);

    try {
      const result: CheckStateResult = await checkState();
      console.log("state result:", result);
      setUserStateInfo(result.userStateInfo);

      // Check if user needs to complete any steps
      const needsCompletion =
        result.userStateInfo.identity_data_completion_needed ||
        result.userStateInfo.package_selection_needed ||
        result.userStateInfo.has_reserved ||
        result.userStateInfo.has_payment_card === null;

      // Check if all user states are false (user is complete)
      const allStatesFalse =
        !result.userStateInfo.identity_data_completion_needed &&
        !result.userStateInfo.package_selection_needed &&
        !result.userStateInfo.has_reserved &&
        result.userStateInfo.has_payment_card !== null;

      console.log(
        "needsCompletion:",
        needsCompletion,
        "allStatesFalse:",
        allStatesFalse,
        "shouldNavigate:",
        result.shouldNavigate
      );

      if (allStatesFalse) {
        // User is complete, navigate directly to dashboard/contact
        console.log(
          "All user states completed - navigating to dashboard/contact"
        );
        navigate("/contact");
        return;
      } else if (needsCompletion) {
        console.log("User needs completion - opening stepper");
        setIsStepperOpen(true);
      } else if (result.shouldNavigate) {
        // User is complete, navigate to dashboard
        console.log("All user states completed - navigating to dashboard");
        navigate(result.navigateTo);
      }
    } catch (error) {
      console.error("Error checking user state:", error);
      // On error, navigate to dashboard as fallback
      navigate("/contact");
      console.log("error checking user state row 55");
    } finally {
      setIsLoading(false);
    }
  }, [navigate, isLoading]);

  const handleStepperComplete = useCallback(() => {
    setIsStepperOpen(false);
    navigate("/contact");
    console.log("handleStepperComplete row 64");
  }, [navigate]);

  const updateUserState = useCallback((updatedState: UserStateInfo) => {
    setUserStateInfo(updatedState);
  }, []);

  return {
    isStepperOpen,
    userStateInfo,
    isLoading,
    checkUserState,
    handleStepperComplete,
    updateUserState,
    openStepper: () => setIsStepperOpen(true),
  };
};
